import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getChargeMappingList(params) {
  return request({
    url: URL.sys.chargeMapping,
    method: 'get',
    params
  })
}

export function saveChargeMapping(data) {
  return request({
    url: URL.sys.chargeMapping,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delChargeMapping(uuid) {
  return request({
    url: URL.sys.chargeMapping + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
